<template>
  <v-container fluid>
    <v-data-iterator
      :items="items"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="search"
      :sort-by="sortBy.toLowerCase()"
      :sort-desc="sortDesc"
      hide-default-footer
    >
      <template v-slot:header>
        <v-toolbar
          
          color="tertiary"
          class="mb-1"
        >
          <v-text-field
            v-model="search"
            clearable
            flat
            solo
            hide-details
            label="Search"
          ></v-text-field>
          <template v-if="$vuetify.breakpoint.mdAndUp">
            <v-spacer></v-spacer>
            <span class='mx-2'>Sort by:</span>
            <v-select
              v-model="sortBy"
              flat
              solo
              item-color="secondary"
              hide-details
              :items="keys"
              label="Sort by"
            ></v-select>
            
          </template>
        </v-toolbar>
      </template>

      <template v-slot:default="props">
        <v-row>
          <v-col
            v-for="item in props.items"
            :key="item.id"
            cols="12"
            sm="6"
            md="6"
            lg="4"
          >
            <v-card
                hover
                min-height = '520px'
                @click.stop="item.dialog = true"        
            >
                <v-card-actions>
                    <GuidanceTag :type='item' :small='true'/>
                </v-card-actions>
                <v-img
                    :src='item.src'
                    class='align-end'
                    height='240px' 
                    contain        
                >
                
                </v-img>
                <v-card-title class='headline'>{{ item.name }}</v-card-title>
                <v-card-subtitle>{{ item.subtitle }}</v-card-subtitle>
                <v-card 
                    outlined
                    width='80%'
                    class="mx-auto my-2"
                >
                    <v-card-title class="justify-center" >
                      {{ Intl.NumberFormat().format(item.totalCarbon) }} 
                      <sub><small>{{item.units}}</small></sub>
                    </v-card-title>
                    <v-card-subtitle class="text-center" dense>Total {{ item.scope }} Equivalent</v-card-subtitle>
                </v-card>
                <v-card-subtitle> {{ item.description }} </v-card-subtitle>
                <v-card-actions>
                  <v-row dense>
                    <v-col align='center'>
                       <v-chip
                      v-for='name in item.authors'
                      :key='name'
                      outlined
                      small
                      color = 'tertiary darken-4'
                      class='mx-1 my-2'
                    >{{ name }}</v-chip>
                    </v-col>
                  </v-row>                    
                </v-card-actions>
                    
            </v-card>
            <!-- Pop up dialog for each object -->
            <TypeDialog :type='item' />    
          </v-col>
        </v-row>
      </template>

      <template v-slot:footer>
        <v-row class="mt-2" align="center" justify="center">

          <v-spacer></v-spacer>

          <span
            class="mr-4
            grey--text"
          >
            Page {{ page }} of {{ numberOfPages }}
          </span>
          <v-btn            
            color="tertiary"
            class="mr-1 mx-2"
            @click="formerPage"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn            
            color="tertiary"
            class="ml-1 mx-2"
            @click="nextPage"
          >
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-row>
      </template>
    </v-data-iterator>
  </v-container>
</template>

<script>
import typologies from '@/store/typologies-infra'
import TypeDialog from '@/components/TypeDialog'
import GuidanceTag from '@/components/GuidanceTag'

export default {
    components: {
        TypeDialog,
        GuidanceTag
    },
    data () {
        return {
            search: '',
            filter: {},
            sortDesc: false,
            page: 1,
            itemsPerPage: 24,
            sortBy: 'category',
            keys: [
                { text: 'Name', value: 'name' },
                { text: 'Region', value: 'region' },
                { text: 'Discipline', value: 'category' },
                { text: 'Sector', value: 'sector' },
            ],
            items: typologies
        }
        },
        computed: {
        numberOfPages () {
            return Math.ceil(this.items.length / this.itemsPerPage)
        },
        filteredKeys () {
            return this.keys.filter(key => key !== `name`)
        },
        },
        methods: {
        nextPage () {
            if (this.page + 1 <= this.numberOfPages) this.page += 1
        },
        formerPage () {
            if (this.page - 1 >= 1) this.page -= 1
        },
        updateItemsPerPage (number) {
            this.itemsPerPage = number
        },
    },
}
</script>